
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCharacterRolesFromDB = () => {
  return useQuery({
    queryKey: ["character-roles-from-db"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("characters")
        .select("role")
        .eq("status", "published")
        .not("role", "is", null);

      if (error) {
        console.error("Error fetching character roles:", error);
        throw error;
      }

      // Get unique roles and sort them
      const uniqueRoles = [...new Set(data.map(item => item.role).filter(Boolean))];
      
      return uniqueRoles
        .sort()
        .map(role => ({
          value: role,
          label: role.charAt(0).toUpperCase() + role.slice(1)
        }));
    },
  });
};
